<template>
    <main class="cart-page default">
        <div class="container" v-if="cart != null">
            <div class="row">
                <div class="cart-page-content col-xl-9 col-lg-8 col-md-12 order-1">
                    <div class="cart-page-title">
                        <h1>سبد خرید</h1>
                    </div>
                    <div style="position:relative;width:100%" class="table-responsive checkout-content default">
                      
                        <table class="table">
                            <div class="loader" style="display:none;position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:10;width:100%;height:100%;"><img style="position:absolute;top:35%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
                            <tbody>
                                <tr :class="['checkout-item','tr-DiscountPercent']" v-for="detail in cart.CartInfo.CartDetails">
                                    <td class="td-img">
                                       <router-link :to="{ name: 'product' , params: { productId: detail.ProductId , productName: detail.ProductName.replace(/\s+/g, '-') }}"><img :src="detail.ProductPicPath" alt="" @error="imageLoadOnError"></router-link> 
                                        <button @click="removeItem(detail.ProductSaleParamId)" class="checkout-btn-remove"></button>
                                    </td>
                                    <td>
                                        <div>
                                            <h3 class="checkout-title">
                                                <router-link :to="{ name: 'product' , params: { productId: detail.ProductId , productName: detail.ProductName.replace(/\s+/g, '-') }}">{{ detail.ProductName }}</router-link> 
                                            </h3>
                                        </div>
                                        <div v-if="detail.IsAvalible != true">
                                            <span class="unavailable">ناموجود ( تعداد موجودی  {{detail.StockInventory}} {{detail.Unit}} )</span>
                                        </div>

                                    </td>
                                    <td class="td-cart-box-counter">
                                        <div class="cart-box-counter">
                                            <i class="incress now-ui-icons ui-1_simple-add" @click="Increase(detail.ProductSaleParamId)"></i>
                                            <span class="count-Item"> {{ detail.Quantity }} {{ detail.Unit  }}</span>
                                            <i class="decress now-ui-icons ui-1_simple-delete" @click="Decrease(detail.ProductSaleParamId)"></i>
                                        </div>
                                    </td>
                                    <td class="td-cart-box-price">
                                        <div class="cart-box-price">
                                            <div>
                                                <div class="discount-detail" v-if="detail.DiscountPercent > 0">
                                                    <div class="line-price">
                                                        <span class="detsail-Price">
                                                            {{detail.Price | formatNumber}}
                                                        </span>
                                                        <span class="txd-toman">تومان</span>
                                                    </div>

                                                </div>
                                                <div>
                                                    <span class="finalPrice">
                                                        {{ detail.FinalPrice | formatNumber }}
                                                    </span>
                                                    <span class="tsd-toman">تومان</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div v-if="detail.DiscountPercent > 0" class="DiscountPercentvalue">  <span class="Percent">%{{detail.DiscountPercent}}</span></div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <aside class="cart-page-aside col-xl-3 col-lg-4 col-md-6 center-section order-2">
                    <div class="checkout-aside">
                        <div class="checkout-summary">
                            <div class="loader" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%;display:none"><img style="position:absolute;top:35%;left:39%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
                            <cart-summary></cart-summary>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </main>
</template>

<script>
    import { setCart } from "../../module/cart";
    import cartSummary from "./cartSummary.vue";
    export default {
        data() {
            return { showLoader: false }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            }
        },
        components: {
            'cart-summary': cartSummary,
        },
        methods: {
            removeItem(productSaleParamId) {

                setCart(this, productSaleParamId, 'RemoveItem', '.loader');
            },
            Increase(productSaleParamId) {
                setCart(this, productSaleParamId, 'Increase', '.loader');
            },
            Decrease(productSaleParamId) {
                setCart(this, productSaleParamId, 'Decrease', '.loader');
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },

        }
    }
</script>

<style scoped>
    .table {
        width: 100%;
        margin-bottom: unset;
        position: relative;
    }
    .unavailable {
        padding: 3px 10px 3px 10px;
        border-radius: 10px;
        color: #fff;
        background-color: #e66363;
        display: inline-block;
    }

    .cart-page .checkout-aside {
        margin-top: 86px;
        margin-bottom: 83px;
    }

    .td-cart-box-price {
        width: 27%;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .unavailable {
            font-size: 12px;
        }
    }

    @media only screen and (min-width: 640px) and (max-width: 850px) {
    }
</style>